angular.module('ui.order.orderItemCard.orderItemFiles.fileUpload', [])

    .directive('fileUpload', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/ui/order/orderItemCard/orderItemFiles/fileUpload/fileUpload.html',
            scope: {
                batchSize: "@",
                concurrencyLevel: "@",
                chunkSize: "@",
                multiple: "@",
                documentVersions: "@",
                cancelled: "&",
                validate: "&",
                reset: "@",
                orderItemId: "@",
                someFileUploaded: "&",
                allUploaded: "&"
            },
            controller: function ($scope, $timeout, $filter, $q, gettextCatalog, toastr, fileService, checkDuplicatesService) {

                //complete = true;
                $scope.dataSizeFilter = $filter('dataSize');
                $scope.uploadId = '';
                $scope.uploadInfo = {count: 0, size: 0};
                $scope.items = [];
                $scope.totalSize = 0;
                $scope.uploading = false;
                $scope.uploadingStopped = false;
                $scope.chunkSize = typeof $scope.chunkSize === 'string' ? parseInt($scope.chunkSize) : 1000000;
                $scope.batchSize = typeof $scope.batchSize === 'string' ? parseInt($scope.batchSize) : 1;
                $scope.concurrencyLevel = typeof $scope.concurrencyLevel === 'string' ? parseInt($scope.batchSize) : 1;

                $scope.conflictWindowOptions = {
                    animation: om.config.kendoWindowDefaultOptions.animation
                }

                $scope.selectedFiles = gettextCatalog.getString('Drag & Drop files here or');
                if (typeof (window.FileReader) == 'undefined') {
                    $scope.selectedFiles = gettextCatalog.getString('No files selected.');
                }
                $scope.openFileDialog = function (e) {
                    if (!$scope.uploading) {
                        $("input[type='file'][name='file']").click();
                    }
                };
                $scope.reset = function () {
                    $scope.uploadInfo = null;
                    $scope.items = [];
                    if (typeof ($scope.documentVersions) == "object") {
                        $scope.documentVersions = {};
                    }
                };

                var removeUploadedProgressBars = function () {
                    if ($scope.isCancelled) {
                        $scope.items = [];
                    } else {
                        if ($scope.uploading) return;
                        $scope.items = _.filter($scope.items, function (value) {
                            return value.finished === false && value.skipped === false;//if status not cancelled clear all finished items
                        });
                    }
                };

                $scope.submit = function () {
                    var deferred = $q.defer();
                    $scope.isCancelled = false;

                    //if ($scope.totalSize == 0) return;
                    $scope.uploading = true;
                    $scope.uploadingStopped = false;

                    if (!$scope.isCancelled && !(typeof $scope.cancelled == 'function' && $scope.cancelled() === true)) {
                        var files = [];
                        if ($scope.validate({uploads: $scope.items}) !== 'undefined' && $scope.validate({uploads: $scope.items}) === false) {
                            $scope.cancelUpload();
                            return;
                        }
                        for (var i = 0; i < $scope.items.length; i++) {
                            if ($scope.items[i].started) continue;
                            files.push($scope.items[i].file);
                            $scope.items[i].started = true;
                        }
                        var fileServicePromise = fileService
                            .uploadFiles(files, $scope.chunkSize, $scope.batchSize, $scope.concurrencyLevel,
                                function () {
                                    return $scope.isCancelled || $scope.cancelled() === true;
                                }, updateProgressCallback, $scope.orderItemId, false)
                            .then(function (result) {
                                $scope.allUploaded();
                            }, function (error) {
                                if (error.data && error.data.ErrorMessage) toastr.error(error.data.ErrorMessage);
                            }).finally(function () {
                                $scope.updateStatus();
                                $timeout(function () {
                                    $scope.$applyAsync(function () {
                                        $scope.uploadingStopped = true;
                                        $scope.uploading = false;
                                    });

                                    $timeout(function () {
                                        $scope.$applyAsync(function () {
                                            removeUploadedProgressBars();
                                        });
                                    }, $scope.isCancelled ? 0 : 2000);
                                }, 100);
                                deferred.resolve();
                            }
                        );
                        //that 'if' used for opportunity of submitting file while another is uploading
                        if (!$scope.FileUploadPromises) {
                            $scope.FileUploadPromises = fileServicePromise;
                        } else {
                            $scope.FileUploadPromises = $scope.FileUploadPromises.then(function () {
                                return fileServicePromise;
                            });
                        }
                    }
                    return deferred.promise;
                };
                $scope.updateStatus = function () {
                    $scope.totalSize = 0;
                    var selected = [];
                    if (!$scope.uploadInfo) $scope.uploadInfo = {count: 0, size: 0};
                    for (var i = 0; i < $scope.items.length; i++) {
                        var item = $scope.items[i];
                        if (!item.finished) {
                            if (item.file.size == 0) continue;
                            $scope.totalSize += item.file.size;
                            selected.push(item.file);
                        } else {
                            $scope.uploadInfo.count++;
                            $scope.uploadInfo.size += item.file.size;
                        }
                    }
                    var uploadedMessage = $scope.uploadInfo.count > 1 || $scope.uploadInfo.count == 0
                        ? 'Uploaded %s files (%s)'
                        : 'Uploaded %s file (%s)';
                    $scope.uploadInfo.text = gettextCatalog.getString(_.str.sprintf(uploadedMessage, $scope.uploadInfo.count, $scope.dataSizeFilter($scope.uploadInfo.size)));
                };
                $scope.itemByFile = function (file) {
                    for (var i in $scope.items) {
                        if ($scope.items[i].file == file) return $scope.items[i];
                    }
                    return null;
                };
                $scope.cancelUpload = function (e) {
                    $scope.isCancelled = true;
                    $scope.uploading = false;

                    if ($scope.conflictWindow.options.visible) {
                        $scope.skipFile(true); //skip all files if conflict window was shown, as we're cancelling anyway
                    }
                    e.preventDefault();
                    e.stopPropagation();
                };
                $scope.onSelect = function (files) {
                    $scope.$apply(function (sc) {
                        for (var i = 0; i < files.length; i++) {
                            var file = files[i];
                            if (file.size == 0) continue;
                            var item = {file: file, progress: 0, started: false, finished: false, skipped: false};
                            sc.items.push(item);
                        }
                    });
                    $scope.submit();
                };

                $scope.replaceFile = function (toAll) {
                    checkDuplicatesService.action = "replace";
                    if ($scope.toAll) checkDuplicatesService.actionToAllFiles = "replace";
                    checkDuplicatesService.pauseDeferred.resolve();
                    $scope.conflictWindow.close();
                };
                $scope.addCopy = function (toAll) {
                    checkDuplicatesService.action = "addcopy";
                    if ($scope.toAll) checkDuplicatesService.actionToAllFiles = "addcopy";
                    checkDuplicatesService.pauseDeferred.resolve();
                    $scope.conflictWindow.close();
                };
                $scope.skipFile = function (toAll) {
                    checkDuplicatesService.action = "skip";
                    if ($scope.toAll) checkDuplicatesService.actionToAllFiles = "skip";
                    checkDuplicatesService.pauseDeferred.resolve();
                    $scope.conflictWindow.close();
                };
                checkDuplicatesService.openConflictWindow = function (name) {
                    $scope.toAll = false;
                    $scope.fileNameConflict = name;
                    $scope.conflictWindow.open();
                };
                
                function updateProgressCallback(file, progress, sessionId, isFinished, isSkipped) {
                    var item = $scope.itemByFile(file);
                    if (item != null) {
                        item.sessionId = sessionId;
                        item.progress = progress;
                        item.finished = isFinished;
                        item.skipped = isSkipped;
                        if (isFinished) {
                            $scope.someFileUploaded();
                        }
                        if (isSkipped) {
                            //var pb = $('#pb' + $scope.items.indexOf(item) + ' span.k-progress-status');
                            //pb.text("bla");
                            //pb.css("color", "red");

                            $('#pb' + $scope.items.indexOf(item)).data("kendoProgressBar").progressStatus.text("skipped");

                        }
                    }
                }

                $scope.progressBarOptions = {
                    max: 100,
                    min: 1,
                    type: "percent"

                }

                $scope.$watch('orderItemId', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        $scope.uploadInfo = null; //reset counters of uploaded files/bytes
                    }
                });
            },
            link: function (scope, element, attrs) {
                var input = element.find("[name='file']");
                var upload = element.find("[name='file-upload']");
                jQuery.event.props.push('dataTransfer');
                upload.on("dragover", function () {
                    upload.addClass('drag-hover');
                    return false;
                });
                upload.on("dragleave", function () {
                    upload.removeClass('drag-hover');
                    return false;
                });
                upload.on("drop", function (event) {
                    scope.onSelect(event.dataTransfer.files);
                    event.preventDefault();
                    upload.removeClass('drag-hover');
                    upload.addClass('drag-drop');
                });

                scope.input = input;
                if (scope.multiple) input.attr('multiple', 'multiple');
                input.on('change', function (e) {
                    scope.onSelect(e.target.files);
                    input.val("");
                });
            }
        };
    });
